import { type ApolloCache, useQuery } from "@apollo/client";

import { gql } from "@medbillai/generated-graphql-types";

import { errorHandling } from "../../lib/apollo/utils";

export const pendingNateraIntakeQuery = gql(/* GraphQL */ `
  query PendingNateraIntake {
    hasPendingNateraIntake
  }
`);

/**
 * Whether the member is holding funnel answers no case has been opened from —
 * the one thing the resume gate needs, read on its own rather than on the boot
 * profile: an API that does not serve the field yet, or a read that fails,
 * costs the redirect and nothing else. `undefined` until it lands, which the
 * gate treats as "let them through".
 */
export function usePendingNateraIntake({ skip }: { skip: boolean }) {
  const { data } = useQuery(pendingNateraIntakeQuery, {
    skip,
    context: errorHandling("caller"),
  });
  return data?.hasPendingNateraIntake;
}

/**
 * Activation owns the answer from the moment it acts on the packet: the server
 * clears it when the case opens, and a member who gives up on a failure has to
 * be able to leave even while it is still there. Either way the gate stops for
 * this session, and the next launch reads the server again.
 *
 * It is not the only thing holding the trap shut, and this is not the hub's
 * only host: the case screen renders it too, and closing it there calls none
 * of this. That exit is safe because `AuthService.hasPendingNateraIntake`
 * answers false once the member owns a Natera case at all — narrowing that
 * predicate back to the packet alone reopens the loop from there.
 */
export function stopGatingActivation(cache: ApolloCache<unknown>) {
  cache.writeQuery({
    query: pendingNateraIntakeQuery,
    data: { __typename: "Query", hasPendingNateraIntake: false },
  });
}
